export const GROWTH_ARTICLE_PUBLISH_CHANNEL = 'web-blog';

export const GROWTH_STOREFRONT_PUBLIC_BASE_URL = 'https://localhost:5001';

export function slugifyArticleTitle(title: string): string {
  // Keep Latin alphanumerics and Persian letters (same range as Growth ACE Slugify).
  return title
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\u0600-\u06FF-]+/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
}

export function buildStorefrontArticleUrl(slug: string | null | undefined, baseUrl = GROWTH_STOREFRONT_PUBLIC_BASE_URL): string {
  const normalizedSlug = (slug ?? '').trim();
  if (!normalizedSlug) {
    return `${baseUrl}/articles`;
  }

  return `${baseUrl}/articles/${encodeURIComponent(normalizedSlug)}`;
}

export function parseChannelKeysFromJson(channelsJson: string | null | undefined): string[] {
  if (!channelsJson) {
    return [];
  }

  try {
    const parsed = JSON.parse(channelsJson) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map(item => {
        if (typeof item === 'string') {
          return item.trim();
        }
        if (item && typeof item === 'object') {
          const record = item as Record<string, unknown>;
          const channelKey = record['channelKey'] ?? record['channel'];
          return typeof channelKey === 'string' ? channelKey.trim() : '';
        }
        return '';
      })
      .filter(item => item.length > 0);
  } catch {
    return [];
  }
}
